import { render, staticRenderFns } from "./CockpitComponent.vue?vue&type=template&id=3f466c6b"
import script from "./CockpitComponent.vue?vue&type=script&lang=js"
export * from "./CockpitComponent.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../node_modules/@vue/vue-loader-v15/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports